module.exports = __webpack_public_path__ + "media/images/terrain de foot-8ed7bb06615f57c1d1f3bb261c222248.svg";